import React from "react";
import { ThemeProvider, createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
*, 
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body{
  color: ${(props) => props.theme["lm-text"]};
  background-color:${(props) => props.theme["lm-bg"]};
}

html:focus-within {
  scroll-behavior: smooth;
}

ul,ol {
  list-style: none;
}

@media screen and (prefers-color-scheme: light) {
  body {
    background-color:${(props) => props.theme["lm-bg"]};
  }
}


@media screen and (prefers-color-scheme: dark) {
  body {
    background-color:${(props) => props.theme["lm-bg"]};
  }
}

@media (prefers-reduced-motion: reduce) {
  html:focus-within {
    scroll-behavior: auto;
  }
}

html {
  font-size: 16px;
}

body {
  font-family:'Space Mono', monospace;
  font-size: 0.875rem;
  counter-reset: tab;
}

a {
  text-decoration: none;
  color: inherit;
}
`;

const Provider = ({ children, theme }) => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </ThemeProvider>
  );
};

export default Provider;
